import type { RenewalData } from '../types';
import { RenewalDtoPeriod } from '../types';

/**
 * قيمة `renewalDto.renewalPeriod` التي يتوقعها الباكند في التجربة الفعلية: **عدد أيام التمديد**
 * (وليس enum بقيم 0/1/2 — إرسال `1` أدى إلى `renewalDays: 1` بدلاً من شهر).
 *
 * - `renewalData.renewalPeriod`: عادة `subscriptionDays` من الملف الشخصي (مثلاً 30).
 * - `renewalDtoPeriod`: عند الحاجة يُحوَّل تقريبياً إلى أيام (يوم / 30 / 60).
 */
export function renewalPeriodDaysForRenewalDto(data: RenewalData): number {
  if (data.renewalDtoPeriod !== undefined && data.renewalDtoPeriod !== null) {
    switch (data.renewalDtoPeriod) {
      case RenewalDtoPeriod.Day:
        return 1;
      case RenewalDtoPeriod.Month:
        return 30;
      case RenewalDtoPeriod.TwoMonths:
        return 60;
      default:
        return 30;
    }
  }
  const p = data.renewalPeriod;
  if (p != null) {
    const n = Math.round(Number(p));
    if (Number.isFinite(n) && n >= 1 && n <= 3660) {
      return n;
    }
  }
  return 30;
}
